module.exports = __webpack_public_path__ + "media/images/stars/1@2x-88ed99f4e14da7bc474f1d16b13c8347.png";